<template>
  <button class="pagination-trigger" @click.prevent="onClick">{{ pageNumber }}</button>
</template>
<script>
export default {
  props: {
    pageNumber: {
      type: Number,
      required: true
    }
  },
  methods: {
    onClick() {
      this.$emit("loadPage", this.pageNumber);
    }
  }
};
</script>

<style scoped>
.pagination-trigger {
  @apply w-6 h-6 border border-gray-600 mx-1 rounded-full leading-snug;
}

.pagination-trigger.current {
  @apply text-white border-pink-500 bg-pink-400;
}

.pagination-trigger:focus {
  outline: none;
}
</style>